module.exports = __webpack_public_path__ + "0367a1dab7.woff2";